import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { FeesService } from './fees.service';

export const Ng1FeesModule = angular
  .module('control-room.shared.services.fees', [])
  .factory('crFeesService', downgradeInjectable(FeesService));